import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { UpsellTransition } from './components/UpsellTransition';
import { MockupComparison } from './components/MockupComparison';
import { PricingSection } from './components/PricingSection';
import { DecisionBox } from './components/DecisionBox';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1688179945683486');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-yellow-200" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <TomosSection data-id="element-6" />
      <BeforeAfterSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <BonusSection data-id="element-9" />
      <UpsellTransition data-id="element-10" />
      <MockupComparison data-id="element-11" />
      <PricingSection data-id="element-12" />
      <DecisionBox data-id="element-13" />
      <GuaranteeSection data-id="element-14" />
      <FAQSection data-id="element-15" />
      <FinalClose data-id="element-16" />
      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />

      {/* Meta Pixel Noscript */}
      <noscript data-id="element-19">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1688179945683486&ev=PageView&noscript=1" data-id="element-20" />
      </noscript>
    </div>;
}